import React, { Dispatch, SetStateAction } from "react";

type UserMenuContext = {
  isUserMenuDisplayed: boolean;
  setIsUserMenuDisplayed: Dispatch<SetStateAction<boolean>>;
};

export default React.createContext<UserMenuContext>({
  isUserMenuDisplayed: false,
  setIsUserMenuDisplayed: (value) => {},
});
